import type { Phone } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCreatePhone as useCreatePhoneAPI } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { usePhones } from "./usePhones"
import { noticeError } from "src/utils"

export function useCreatePhone() {
  const createPhone = useCreatePhoneAPI()
  const {
    mutate,
    data: phones,
  } = usePhones()

  return useMemo(
    () => createPhone && (async (phone: Partial<Phone>) => {
      try {
        const response = await createPhone(phone)

        if (phones) {
          void mutate([
            response.data.phone,
            ...phones,
          ])
        } else {
          void mutate()
        }

        return response
      } catch (e) {
        noticeError(
          e,
          "CreatePhone",
          { phone },
        )
        throw e
      }
    }),
    [
      createPhone,
      phones,
      mutate,
    ],
  )
}
